module.exports = __webpack_public_path__ + "static/media/users.fe1d622e.svg";